"use strict";
/**
 * @module V4Stack
 */
Object.defineProperty(exports, "__esModule", { value: true });
var connection_1 = require("./../v4-stack/connection");
/**
 * Provide a factory for creating connections with provided Transport instances
 *
 * @param  transports          the transports that can be used for the connecttion
 * @param  reconnectTimeout    a reconnection timeout
 * @param  recoveryBufferSize  size of the recovery buffer
 *
 * @return                     a new {@link Connection}
 */
function create(transports, reconnectTimeout, recoveryBufferSize) {
    return new connection_1.Connection(transports, reconnectTimeout, recoveryBufferSize);
}
exports.create = create;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/v4-stack/connection-factory.js
// module id = 1423
// module chunks = 1